import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';
import type { Branch } from '../use-get-store-order';

/**
 * Default search radius (mét) cho các call getStoresFn có kèm lat/lng.
 * `radius` là param BẮT BUỘC khi gửi lat/lng — mọi call site phải dùng constant này
 * (trừ filter "gần tôi" cố tình override 5000m). Xem simple-store-list, store-list-client,
 * server-location-utils, [...slug]/page.tsx.
 */
export const DEFAULT_STORE_RADIUS = 20000;

export interface Promo1 {
  description: string;
  promo_code: string;
}

export interface OpenHour {
  start_time: number;
  end_time: number;
}

export interface HighlightItem {
  _id: number;
  name: string;
  score: number;
  price: number;
  image_thumb_url: string;
  image_preview_url: string;
  /** Khung chiến dịch (AF-063) — vắng hẳn khi món không thuộc chiến dịch. */
  frame_image_url?: string;
}
export interface Store {
  page_id: number;
  city_id: string;
  name: string;
  ai_tags: string[];
  parent: string;
  is_closed: boolean;
  auto_confirm: boolean;
  auto_payout: boolean;
  image_url: string;
  mobile: string;
  payment_account: string;
  management_account: string;
  payment_methods: [string];
  distance: number;
  parking_fee: number;
  open_dates: any[];
  available_to: any[];
  address: string;
  promo1: Promo1;
  description: string;
  create_at: number;
  update_at: number;
  open_hours: Record<string, OpenHour[]>;
  location: Location;
  admin_note: string;
  type: string;
  short_promo: string;
  _id: number;
  tags: any[];
  verified: boolean;
  is_active: boolean;
  menu_images: string[];
  menu_link: string[];
  promotion_info: string;
  fb_fanpage?: string;
  slug: string;
  branches: Branch[];
  highlight_items?: HighlightItem[];
  nearest_branch: NearestBranch;
  is_temporary_closed: boolean;
  rating: Rating;
  tag: any[];
  total_sold: number;
  summary_review: SummaryReview;
}
export interface Rating {
  google_total: number;
  google_average: number;
  total: number;
  average: number;
  detail: DetailRating;
}

export interface DetailRating {
  '1': number;
  '2': number;
  '3': number;
  '4': number;
  '5': number;
}

export interface SummaryReview {
  general_summary: string;
  highlights: string;
  lowlights: string;
  percentage_negative_comment: number;
}

export interface NearestBranch {
  id: string;
  address: string;
  mobile: string;
  status: string;
  location: Location;
}
export interface Location {
  type: string;
  coordinates: [number, number];
}

export interface StoresResponse {
  total: number;
  stores: Store[];
}
export interface GetStoresResquestParams {
  text?: string;
  category_slug?: string;
  limit?: number;
  radius?: number;
  lat?: number;
  lng?: number;
  city_id: string;
  skip?: number;
  campaign_id?: string;
  special_request?: string;
  item_tag?: string;
}
export const getStoresFn = async (
  params: GetStoresResquestParams,
  config: AxiosRequestConfig = {}
) => {
  const response = await publicHttpClient.get<StoresResponse>(
    apiRoutes.ahafood.store.get_store,
    {
      params,
      ...config,
    }
  );

  return response?.data;
};
